
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"14","r":"14","fill":"#fff"}}),_c('path',{attrs:{"d":"M15.873 7.53l5.02-.02-.02 5.02M15.66 12.64l5.08-5.08M20.873 15.873l.02 5.02-5.02-.02M15.764 15.66l5.08 5.079M7.53 15.873l-.02 5.02 5.02-.02M12.64 15.66l-5.08 5.079M12.53 7.53l-5.02-.02.02 5.02M12.744 12.64l-5.08-5.08","stroke":"#8C897F"}})])
          )
        }
      }
    